import { Injectable } from "@angular/core";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class LoginYearlyReviewConfigService {
	constructor(private configService: ConfigService) {}

	isLoginYearlyReviewDialogEnabled(): boolean {
		return this.configService.get((x) => x.common.loginYearlyReview.isEnabled, false);
	}
}
